<div class="bn-email-confirmed d-flex justify-content-center align-items-center text-center">
  <div>
    <div class="bn-email-confirmed__title">Thank you!</div>
    <div class="bn-email-confirmed__description my-3">Your email has been confirmed.</div>
    <bn-web-ui-button
      data-e2e="AuthPagesEmailConfirmedGoToDashboardButton"
      itemStyle="secondary"
      routerLink="/"
      size="lg">
      Go to Dashboard
    </bn-web-ui-button>
    <div class="bn-email-confirmed__image">
      <img src="/assets/libs/auth-pages/images/bunny-email-confirmed.svg" />
    </div>
  </div>
</div>
